// DO NOT EDIT THIS FILE MANUALLY
// This file was auto-generated by running scripts/i18n/language_tags/generate_all_locales.py

/**
 * A string enum with the locales accepted by Benchling.
 * Generated by scripts/i18n/language_tags/generate_all_locales.py and automatically kept in sync with scripts/i18n/languageTags.json.
 */
export enum BenchlingLocale {
  BNCH_12HR = 'bnch-12hr',
  BNCH_24HR = 'bnch-24hr',
  AF = 'af',
  AF_NA = 'af-NA',
  AF_ZA = 'af-ZA',
  AK = 'ak',
  SQ = 'sq',
  SQ_AL = 'sq-AL',
  AR = 'ar',
  AR_MA = 'ar-MA',
  AR_AR = 'ar-AR',
  AR_SA = 'ar-SA',
  HY_AM = 'hy-AM',
  AZ = 'az',
  AZ_AZ = 'az-AZ',
  EU = 'eu',
  EU_ES = 'eu-ES',
  BE_BY = 'be-BY',
  BN = 'bn',
  BN_BD = 'bn-BD',
  BN_IN = 'bn-IN',
  BS_BA = 'bs-BA',
  BG = 'bg',
  BG_BG = 'bg-BG',
  MY = 'my',
  CA = 'ca',
  CA_ES = 'ca-ES',
  ZH = 'zh',
  ZH_HANS = 'zh-Hans',
  ZH_CN = 'zh-CN',
  ZH_SG = 'zh-SG',
  ZH_HANT = 'zh-Hant',
  ZH_HK = 'zh-HK',
  ZH_TW = 'zh-TW',
  HR = 'hr',
  HR_HR = 'hr-HR',
  CS = 'cs',
  CS_CZ = 'cs-CZ',
  DA = 'da',
  DA_DK = 'da-DK',
  NL = 'nl',
  NL_BE = 'nl-BE',
  NL_NL = 'nl-NL',
  EN = 'en',
  EN_AU = 'en-AU',
  EN_CA = 'en-CA',
  EN_IN = 'en-IN',
  EN_IE = 'en-IE',
  EN_ZA = 'en-ZA',
  EN_GB = 'en-GB',
  EN_US = 'en-US',
  EO = 'eo',
  EO_EO = 'eo-EO',
  ET = 'et',
  ET_EE = 'et-EE',
  FO_FO = 'fo-FO',
  TL = 'tl',
  TL_PH = 'tl-PH',
  FI = 'fi',
  FI_FI = 'fi-FI',
  FR = 'fr',
  FR_BE = 'fr-BE',
  FR_CA = 'fr-CA',
  FR_FR = 'fr-FR',
  FR_CH = 'fr-CH',
  FY_NL = 'fy-NL',
  FF = 'ff',
  GL = 'gl',
  GL_ES = 'gl-ES',
  KA_GE = 'ka-GE',
  DE = 'de',
  DE_AT = 'de-AT',
  DE_DE = 'de-DE',
  DE_CH = 'de-CH',
  EL = 'el',
  EL_GR = 'el-GR',
  GU_IN = 'gu-IN',
  HE = 'he',
  HE_IL = 'he-IL',
  HI = 'hi',
  HI_IN = 'hi-IN',
  HU = 'hu',
  HU_HU = 'hu-HU',
  IS = 'is',
  IS_IS = 'is-IS',
  ID = 'id',
  ID_ID = 'id-ID',
  GA = 'ga',
  GA_IE = 'ga-IE',
  IT = 'it',
  IT_IT = 'it-IT',
  JA = 'ja',
  JA_JP = 'ja-JP',
  JV_ID = 'jv-ID',
  KAB = 'kab',
  KN = 'kn',
  KN_IN = 'kn-IN',
  KK_KZ = 'kk-KZ',
  KM = 'km',
  KM_KH = 'km-KH',
  KO = 'ko',
  KO_KR = 'ko-KR',
  KU_TR = 'ku-TR',
  LA = 'la',
  LV = 'lv',
  LV_LV = 'lv-LV',
  LT = 'lt',
  LT_LT = 'lt-LT',
  DSB = 'dsb',
  LB = 'lb',
  MK = 'mk',
  MK_MK = 'mk-MK',
  MAI = 'mai',
  MG_MG = 'mg-MG',
  MS = 'ms',
  MS_MY = 'ms-MY',
  ML = 'ml',
  ML_IN = 'ml-IN',
  MT = 'mt',
  MT_MT = 'mt-MT',
  MR = 'mr',
  MR_IN = 'mr-IN',
  MN_MN = 'mn-MN',
  NE = 'ne',
  NE_NP = 'ne-NP',
  SE_NO = 'se-NO',
  NO = 'no',
  NB = 'nb',
  NB_NO = 'nb-NO',
  NN_NO = 'nn-NO',
  OR_IN = 'or-IN',
  PS_AF = 'ps-AF',
  FA = 'fa',
  FA_IR = 'fa-IR',
  PL = 'pl',
  PL_PL = 'pl-PL',
  PT = 'pt',
  PT_BR = 'pt-BR',
  PT_PT = 'pt-PT',
  PA = 'pa',
  PA_IN = 'pa-IN',
  QU_PE = 'qu-PE',
  RO = 'ro',
  RO_RO = 'ro-RO',
  RM_CH = 'rm-CH',
  RU = 'ru',
  RU_RU = 'ru-RU',
  SA_IN = 'sa-IN',
  SR = 'sr',
  SR_RS = 'sr-RS',
  SI_LK = 'si-LK',
  SK = 'sk',
  SK_SK = 'sk-SK',
  SL = 'sl',
  SL_SI = 'sl-SI',
  SO_SO = 'so-SO',
  ES = 'es',
  ES_AR = 'es-AR',
  ES_CL = 'es-CL',
  ES_CO = 'es-CO',
  ES_EC = 'es-EC',
  ES_419 = 'es-419',
  ES_LA = 'es-LA',
  ES_MX = 'es-MX',
  ES_NI = 'es-NI',
  ES_ES = 'es-ES',
  ES_US = 'es-US',
  ES_VE = 'es-VE',
  SU = 'su',
  SW = 'sw',
  SW_KE = 'sw-KE',
  SV = 'sv',
  SV_SE = 'sv-SE',
  TG = 'tg',
  TG_TJ = 'tg-TJ',
  TA = 'ta',
  TA_IN = 'ta-IN',
  TT_RU = 'tt-RU',
  TE = 'te',
  TE_IN = 'te-IN',
  TH = 'th',
  TH_TH = 'th-TH',
  TR = 'tr',
  TR_TR = 'tr-TR',
  UK = 'uk',
  UK_UA = 'uk-UA',
  HSB = 'hsb',
  UR = 'ur',
  UR_PK = 'ur-PK',
  UZ = 'uz',
  UZ_UZ = 'uz-UZ',
  VI = 'vi',
  VI_VN = 'vi-VN',
  CY = 'cy',
  CY_GB = 'cy-GB',
  XH_ZA = 'xh-ZA',
  YI = 'yi',
  ZU_ZA = 'zu-ZA',
}

/**
 * Mapping from locale code to locale name.
 * Generated by scripts/i18n/language_tags/generate_all_locales.py and automatically kept in sync with scripts/i18n/languageTags.json.
 */
export const LOCALE_ENUM_TO_NAME: {[key in BenchlingLocale]: string} = {
  [BenchlingLocale.BNCH_12HR]: 'International (12 hour)',
  [BenchlingLocale.BNCH_24HR]: 'International (24 hour)',
  [BenchlingLocale.AF]: 'Afrikaans',
  [BenchlingLocale.AF_NA]: 'Afrikaans (Namibia)',
  [BenchlingLocale.AF_ZA]: 'Afrikaans (South Africa)',
  [BenchlingLocale.AK]: 'Akan',
  [BenchlingLocale.SQ]: 'Albanian',
  [BenchlingLocale.SQ_AL]: 'Albanian (Regional)',
  [BenchlingLocale.AR]: 'Arabic',
  [BenchlingLocale.AR_MA]: 'Arabic (Morocco)',
  [BenchlingLocale.AR_AR]: 'Arabic (Regional)',
  [BenchlingLocale.AR_SA]: 'Arabic (Saudi Arabia)',
  [BenchlingLocale.HY_AM]: 'Armenian',
  [BenchlingLocale.AZ]: 'Azerbaijani',
  [BenchlingLocale.AZ_AZ]: 'Azerbaijani (Regional)',
  [BenchlingLocale.EU]: 'Basque',
  [BenchlingLocale.EU_ES]: 'Basque (Regional)',
  [BenchlingLocale.BE_BY]: 'Belarusian',
  [BenchlingLocale.BN]: 'Bengali',
  [BenchlingLocale.BN_BD]: 'Bengali (Bangladesh)',
  [BenchlingLocale.BN_IN]: 'Bengali (India)',
  [BenchlingLocale.BS_BA]: 'Bosnian',
  [BenchlingLocale.BG]: 'Bulgarian',
  [BenchlingLocale.BG_BG]: 'Bulgarian (Regional)',
  [BenchlingLocale.MY]: 'Burmese',
  [BenchlingLocale.CA]: 'Catalan',
  [BenchlingLocale.CA_ES]: 'Catalan (Regional)',
  [BenchlingLocale.ZH]: 'Chinese',
  [BenchlingLocale.ZH_HANS]: 'Chinese Simplified',
  [BenchlingLocale.ZH_CN]: 'Chinese Simplified (China)',
  [BenchlingLocale.ZH_SG]: 'Chinese Simplified (Singapore)',
  [BenchlingLocale.ZH_HANT]: 'Chinese Traditional',
  [BenchlingLocale.ZH_HK]: 'Chinese Traditional (Hong Kong)',
  [BenchlingLocale.ZH_TW]: 'Chinese Traditional (Taiwan)',
  [BenchlingLocale.HR]: 'Croatian',
  [BenchlingLocale.HR_HR]: 'Croatian (Regional)',
  [BenchlingLocale.CS]: 'Czech',
  [BenchlingLocale.CS_CZ]: 'Czech (Regional)',
  [BenchlingLocale.DA]: 'Danish',
  [BenchlingLocale.DA_DK]: 'Danish (Regional)',
  [BenchlingLocale.NL]: 'Dutch',
  [BenchlingLocale.NL_BE]: 'Dutch (Belgium)',
  [BenchlingLocale.NL_NL]: 'Dutch (Netherlands)',
  [BenchlingLocale.EN]: 'English',
  [BenchlingLocale.EN_AU]: 'English (Australia)',
  [BenchlingLocale.EN_CA]: 'English (Canada)',
  [BenchlingLocale.EN_IN]: 'English (India)',
  [BenchlingLocale.EN_IE]: 'English (Ireland)',
  [BenchlingLocale.EN_ZA]: 'English (South Africa)',
  [BenchlingLocale.EN_GB]: 'English (UK)',
  [BenchlingLocale.EN_US]: 'English (US)',
  [BenchlingLocale.EO]: 'Esperanto',
  [BenchlingLocale.EO_EO]: 'Esperanto (Regional)',
  [BenchlingLocale.ET]: 'Estonian',
  [BenchlingLocale.ET_EE]: 'Estonian (Estonia)',
  [BenchlingLocale.FO_FO]: 'Faroese',
  [BenchlingLocale.TL]: 'Filipino',
  [BenchlingLocale.TL_PH]: 'Filipino (Regional)',
  [BenchlingLocale.FI]: 'Finnish',
  [BenchlingLocale.FI_FI]: 'Finnish (Regional)',
  [BenchlingLocale.FR]: 'French',
  [BenchlingLocale.FR_BE]: 'French (Belgium)',
  [BenchlingLocale.FR_CA]: 'French (Canada)',
  [BenchlingLocale.FR_FR]: 'French (France)',
  [BenchlingLocale.FR_CH]: 'French (Switzerland)',
  [BenchlingLocale.FY_NL]: 'Frisian (West)',
  [BenchlingLocale.FF]: 'Fulah',
  [BenchlingLocale.GL]: 'Galician',
  [BenchlingLocale.GL_ES]: 'Galician (Regional)',
  [BenchlingLocale.KA_GE]: 'Georgian',
  [BenchlingLocale.DE]: 'German',
  [BenchlingLocale.DE_AT]: 'German (Austria)',
  [BenchlingLocale.DE_DE]: 'German (Germany)',
  [BenchlingLocale.DE_CH]: 'German (Switzerland)',
  [BenchlingLocale.EL]: 'Greek',
  [BenchlingLocale.EL_GR]: 'Greek (Greece)',
  [BenchlingLocale.GU_IN]: 'Gujarati',
  [BenchlingLocale.HE]: 'Hebrew',
  [BenchlingLocale.HE_IL]: 'Hebrew (Regional)',
  [BenchlingLocale.HI]: 'Hindi',
  [BenchlingLocale.HI_IN]: 'Hindi (Regional)',
  [BenchlingLocale.HU]: 'Hungarian',
  [BenchlingLocale.HU_HU]: 'Hungarian (Regional)',
  [BenchlingLocale.IS]: 'Icelandic',
  [BenchlingLocale.IS_IS]: 'Icelandic (Iceland)',
  [BenchlingLocale.ID]: 'Indonesian',
  [BenchlingLocale.ID_ID]: 'Indonesian (Regional)',
  [BenchlingLocale.GA]: 'Irish',
  [BenchlingLocale.GA_IE]: 'Irish (Gaelic)',
  [BenchlingLocale.IT]: 'Italian',
  [BenchlingLocale.IT_IT]: 'Italian (Regional)',
  [BenchlingLocale.JA]: 'Japanese',
  [BenchlingLocale.JA_JP]: 'Japanese (Regional)',
  [BenchlingLocale.JV_ID]: 'Javanese',
  [BenchlingLocale.KAB]: 'Kabyle',
  [BenchlingLocale.KN]: 'Kannada',
  [BenchlingLocale.KN_IN]: 'Kannada (India)',
  [BenchlingLocale.KK_KZ]: 'Kazakh',
  [BenchlingLocale.KM]: 'Khmer',
  [BenchlingLocale.KM_KH]: 'Khmer (Regional)',
  [BenchlingLocale.KO]: 'Korean',
  [BenchlingLocale.KO_KR]: 'Korean (Korea)',
  [BenchlingLocale.KU_TR]: 'Kurdish',
  [BenchlingLocale.LA]: 'Latin',
  [BenchlingLocale.LV]: 'Latvian',
  [BenchlingLocale.LV_LV]: 'Latvian (Regional)',
  [BenchlingLocale.LT]: 'Lithuanian',
  [BenchlingLocale.LT_LT]: 'Lithuanian (Regional)',
  [BenchlingLocale.DSB]: 'Lower Sorbian',
  [BenchlingLocale.LB]: 'Luxembourgish',
  [BenchlingLocale.MK]: 'Macedonian',
  [BenchlingLocale.MK_MK]: 'Macedonian (Macedonian)',
  [BenchlingLocale.MAI]: 'Maithili',
  [BenchlingLocale.MG_MG]: 'Malagasy',
  [BenchlingLocale.MS]: 'Malay',
  [BenchlingLocale.MS_MY]: 'Malay (Regional)',
  [BenchlingLocale.ML]: 'Malayalam',
  [BenchlingLocale.ML_IN]: 'Malayalam (Regional)',
  [BenchlingLocale.MT]: 'Maltese',
  [BenchlingLocale.MT_MT]: 'Maltese (Regional)',
  [BenchlingLocale.MR]: 'Marathi',
  [BenchlingLocale.MR_IN]: 'Marathi (Regional)',
  [BenchlingLocale.MN_MN]: 'Mongolian',
  [BenchlingLocale.NE]: 'Nepali',
  [BenchlingLocale.NE_NP]: 'Nepali (Regional)',
  [BenchlingLocale.SE_NO]: 'Northern Sámi',
  [BenchlingLocale.NO]: 'Norwegian',
  [BenchlingLocale.NB]: 'Norwegian (bokmal)',
  [BenchlingLocale.NB_NO]: 'Norwegian (bokmal) (Regional)',
  [BenchlingLocale.NN_NO]: 'Norwegian (nynorsk)',
  [BenchlingLocale.OR_IN]: 'Oriya',
  [BenchlingLocale.PS_AF]: 'Pashto',
  [BenchlingLocale.FA]: 'Persian',
  [BenchlingLocale.FA_IR]: 'Persian (Regional)',
  [BenchlingLocale.PL]: 'Polish',
  [BenchlingLocale.PL_PL]: 'Polish (Regional)',
  [BenchlingLocale.PT]: 'Portuguese',
  [BenchlingLocale.PT_BR]: 'Portuguese (Brazil)',
  [BenchlingLocale.PT_PT]: 'Portuguese (Portugal)',
  [BenchlingLocale.PA]: 'Punjabi',
  [BenchlingLocale.PA_IN]: 'Punjabi (India)',
  [BenchlingLocale.QU_PE]: 'Quechua',
  [BenchlingLocale.RO]: 'Romanian',
  [BenchlingLocale.RO_RO]: 'Romanian (Regional)',
  [BenchlingLocale.RM_CH]: 'Romansh',
  [BenchlingLocale.RU]: 'Russian',
  [BenchlingLocale.RU_RU]: 'Russian (Regional)',
  [BenchlingLocale.SA_IN]: 'Sanskrit',
  [BenchlingLocale.SR]: 'Serbian',
  [BenchlingLocale.SR_RS]: 'Serbian (Serbia)',
  [BenchlingLocale.SI_LK]: 'Sinhala (Sri Lanka)',
  [BenchlingLocale.SK]: 'Slovak',
  [BenchlingLocale.SK_SK]: 'Slovak (Slovakia)',
  [BenchlingLocale.SL]: 'Slovenian',
  [BenchlingLocale.SL_SI]: 'Slovenian (Regional)',
  [BenchlingLocale.SO_SO]: 'Somali',
  [BenchlingLocale.ES]: 'Spanish',
  [BenchlingLocale.ES_AR]: 'Spanish (Argentina)',
  [BenchlingLocale.ES_CL]: 'Spanish (Chile)',
  [BenchlingLocale.ES_CO]: 'Spanish (Colombia)',
  [BenchlingLocale.ES_EC]: 'Spanish (Ecuador)',
  [BenchlingLocale.ES_419]: 'Spanish (Latin America) (es-419)',
  [BenchlingLocale.ES_LA]: 'Spanish (Latin America) (es-LA)',
  [BenchlingLocale.ES_MX]: 'Spanish (Mexico)',
  [BenchlingLocale.ES_NI]: 'Spanish (Nicaragua)',
  [BenchlingLocale.ES_ES]: 'Spanish (Spain)',
  [BenchlingLocale.ES_US]: 'Spanish (United States)',
  [BenchlingLocale.ES_VE]: 'Spanish (Venezuela)',
  [BenchlingLocale.SU]: 'Sundanese',
  [BenchlingLocale.SW]: 'Swahili',
  [BenchlingLocale.SW_KE]: 'Swahili (Kenya)',
  [BenchlingLocale.SV]: 'Swedish',
  [BenchlingLocale.SV_SE]: 'Swedish (Regional)',
  [BenchlingLocale.TG]: 'Tajik',
  [BenchlingLocale.TG_TJ]: 'Tajik (Regional)',
  [BenchlingLocale.TA]: 'Tamil',
  [BenchlingLocale.TA_IN]: 'Tamil (Regional)',
  [BenchlingLocale.TT_RU]: 'Tatar',
  [BenchlingLocale.TE]: 'Telugu',
  [BenchlingLocale.TE_IN]: 'Telugu (Regional)',
  [BenchlingLocale.TH]: 'Thai',
  [BenchlingLocale.TH_TH]: 'Thai (Thailand)',
  [BenchlingLocale.TR]: 'Turkish',
  [BenchlingLocale.TR_TR]: 'Turkish (Regional)',
  [BenchlingLocale.UK]: 'Ukrainian',
  [BenchlingLocale.UK_UA]: 'Ukrainian (Regional)',
  [BenchlingLocale.HSB]: 'Upper Sorbian',
  [BenchlingLocale.UR]: 'Urdu',
  [BenchlingLocale.UR_PK]: 'Urdu (Regional)',
  [BenchlingLocale.UZ]: 'Uzbek',
  [BenchlingLocale.UZ_UZ]: 'Uzbek (Regional)',
  [BenchlingLocale.VI]: 'Vietnamese',
  [BenchlingLocale.VI_VN]: 'Vietnamese (Regional)',
  [BenchlingLocale.CY]: 'Welsh',
  [BenchlingLocale.CY_GB]: 'Welsh (Regional)',
  [BenchlingLocale.XH_ZA]: 'Xhosa',
  [BenchlingLocale.YI]: 'Yiddish',
  [BenchlingLocale.ZU_ZA]: 'Zulu',
};
